<script lang="ts">
  import LetterPreviewPanel from "../../_shared/_modules/letter-preview-panel"
  let {
    preview,
  }: {
    preview: () => { url: string | null; pageCount: number; stale: boolean; pending: boolean }
  } = $props()
</script>

<LetterPreviewPanel {...preview()} />
